import { EditorState, Modifier, SelectionState } from 'draft-js';
import { PureComponent } from 'react';

import AlignmentControls from './AlignmentControls';
import FloatControls from './FloatControls';
import ImageControlsCtnr from './ImageControlsCtnr';
import SolutionsControls from './SolutionsControls';
import ToolbarButton from './ToolbarButton';
import ToolbarDivider from './ToolbarDivider';

import { faCrop, faDistributeSpacingHorizontal } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class ImageToolbar extends PureComponent {
  state = { showDialog: false };

  closeDialog = () => {
    const { onSetActive, onSetHidden } = this.props;
    this.setState({ showDialog: false });
    onSetActive(false);
    onSetHidden(false);
  };

  updateImageData = newImageData => {
    const { block, editorState, onChange, onFocus } = this.props;
    const contentState = editorState.getCurrentContent();
    const entityKey = block.getEntityAt(0);
    const updatedContentState = contentState.replaceEntityData(entityKey, {
      url: newImageData.url,
      id: newImageData.id,
    });
    const newEditorState = EditorState.push(editorState, updatedContentState, 'apply-entity');
    onChange(newEditorState, true);
    onFocus();
    this.closeDialog();
  };

  convertToInline = () => {
    const { block, editorState, onChange, onFocus } = this.props;
    const contentState = editorState.getCurrentContent();
    const entityKey = block.getEntityAt(0);
    const entityData = contentState.getEntity(entityKey).getData();

    const beforeBlock = contentState.getBlockBefore(block.getKey());
    const afterBlock = contentState.getBlockAfter(block.getKey());
    if (!beforeBlock && !afterBlock) return;

    const targetBlockKey = beforeBlock ? beforeBlock.getKey() : afterBlock.getKey();
    const targetOffset = beforeBlock ? beforeBlock.getLength() : 0;

    let newContentState = Modifier.removeRange(
      contentState,
      SelectionState.createEmpty().merge({
        anchorKey: (beforeBlock || block).getKey(),
        anchorOffset: beforeBlock ? beforeBlock.getLength() : 0,
        focusKey: (afterBlock || block).getKey(),
        focusOffset: afterBlock ? 0 : block.getLength(),
      }),
      'backward',
    );

    newContentState = newContentState.createEntity('IMAGE', 'IMMUTABLE', entityData);
    const newEntityKey = newContentState.getLastCreatedEntityKey();

    newContentState = Modifier.insertText(
      newContentState,
      SelectionState.createEmpty(targetBlockKey).merge({
        anchorOffset: targetOffset,
        focusOffset: targetOffset,
      }),
      ' ',
      null,
      newEntityKey,
    );

    const newEditorState = EditorState.push(editorState, newContentState, 'apply-entity');
    onChange(newEditorState);
    onFocus();
  };

  render() {
    const { block, editorState, onSetActive, onSetHidden, onUpdateBlockData, plugins } = this.props;
    const { showDialog } = this.state;
    const blockData = block.getData();
    const contentState = editorState.getCurrentContent();
    const imgEntity = contentState.getEntity(block.getEntityAt(0));
    const { id } = imgEntity.getData();
    return (
      <>
        <AlignmentControls blockData={blockData} onUpdateBlockData={onUpdateBlockData} />
        <FloatControls blockData={blockData} onUpdateBlockData={onUpdateBlockData} />
        <ToolbarButton
          onToggle={() => {
            onSetActive(true, 'IMAGE');
            onSetHidden(true);
            this.setState({ showDialog: true });
          }}
          tooltip="Crop Image"
        >
          <FontAwesomeIcon icon={faCrop} />
        </ToolbarButton>
        <ToolbarButton onToggle={this.convertToInline} tooltip="Convert to inline image">
          <FontAwesomeIcon icon={faDistributeSpacingHorizontal} />
        </ToolbarButton>
        <ToolbarDivider />
        {plugins?.solutions && <SolutionsControls blockData={blockData} onUpdateBlockData={onUpdateBlockData} />}
        {showDialog && (
          <ImageControlsCtnr
            imgId={id}
            onClose={this.closeDialog}
            onEditComplete={this.updateImageData}
            showDialog={this.state.showDialog}
          />
        )}
      </>
    );
  }
}
